import * as React from "react";
import * as cn from "classnames/bind";
import { CalendarState } from "burde";
import * as ButtonStyles from "content/button/button.css";
import * as styles from "./user-area.css";
import { actionCreators as uiActionCreators } from "ui/store";
import { actionCreators } from "page/calendar/store";
import { actionCreators as userActionCreators } from "user/store";

const cx = cn.bind({ ...styles, ...ButtonStyles });

const impressumLinkCn = () =>
    cx({
        impressumLink: true,
    });

type UserAreaProps = {
    UserArea_LoginRequired: string;
    UserArea_Menu: string;
    isAuthenticated: boolean;
    calendar: CalendarState;
    showSaveDialog: boolean;
} & typeof actionCreators &
    typeof uiActionCreators &
    typeof userActionCreators;

interface UserAreaState {
    saveResultDialogIsOpen: boolean;
    saveText: string;
}

class UserArea extends React.Component<UserAreaProps, UserAreaState> {
    state: UserAreaState = {
        saveResultDialogIsOpen: false,
        saveText: "",
    };

    public render() {
        const { isAuthenticated } = this.props;
        const { UserArea_Menu, UserArea_LoginRequired } = this.props;

        return (
            <div
                style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    alignContent: "center",
                }}>
                <div
                    style={{
                        display: "block",
                        margin: "20px 0 0 20px",
                        width: "80px",
                    }}>
                    <img src={"images/logotype.svg"} />
                </div>
                <div
                    style={{
                        position: "absolute",
                        top: "0px",
                        right: "20px",
                        textAlign: "right",
                    }}>
                    <div
                        style={{
                            height: "50px",
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                        }}>
                        <div>
                            {!isAuthenticated && (
                                <a
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: "#5cbbc9",
                                        cursor: "pointer",
                                    }}
                                    onClick={() =>
                                        this.props.updateShowLoginModal(true)
                                    }>
                                    <i
                                        style={{ color: "#424A4C" }}
                                        className={"fas fa-lock"}
                                    />{" "}
                                    {UserArea_LoginRequired}
                                </a>
                            )}
                            {isAuthenticated && (
                                <a
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: "14px",
                                        color: "#5cbbc9",
                                        cursor: "pointer",
                                    }}
                                    onClick={() => {
                                        this.props.UpdateShowUserMenu(true);
                                    }}>
                                    <i
                                        style={{ color: "#424A4C" }}
                                        className={"fas fa-bars"}
                                    />{" "}
                                    {UserArea_Menu}
                                </a>
                            )}
                            {this.props.calendar.culture == "de-DE" && (
                                <a
                                    className={impressumLinkCn()}
                                    href="https://sotypicalme.de/impressum/"
                                    target="blank">
                                    <span> | </span>
                                    Impressum
                                </a>
                            )}
                            {this.props.calendar.culture == "de-AT" && (
                                <a
                                    className={impressumLinkCn()}
                                    href="https://sotypicalme.at/impressum/"
                                    target="blank">
                                    <span> | </span>
                                    Impressum
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserArea;
